import {
  SisterSearcherPerformancePointKey,
  SisterSearcherPerformanceScopeKey,
  SisterSearcherSimilarityKey,
  SisterSearcherVessel,
} from "../models/sister-searcher.models";

export const SISTER_SEARCHER_ALLOWED_SUBJECTS = [
  "adrian_moisa@crgl-thirdparty.com",
  "guilhem_servet@cargill.com",
] as const;

export const SISTER_SEARCHER_RESULT_LIMIT = 200;
export const SISTER_SEARCHER_VESSEL_OPTION_LIMIT = 50;
export const SISTER_SEARCHER_PERFORMANCE_LIMIT = 201;
export const SISTER_SEARCHER_MODELED_DWT_TOLERANCE = 500;

export const SISTER_SEARCHER_SIMILARITY_OPTIONS: ReadonlyArray<{
  key: SisterSearcherSimilarityKey;
  label: string;
}> = [
  { key: "sameCountryOfBuild", label: "Same Country of Build" },
  { key: "sameDesign", label: "Same Design" },
  { key: "sameDwt", label: "Same DWT" },
  { key: "sameEngine", label: "Same Engine" },
  { key: "sameYard", label: "Same Yard" },
];

export const SISTER_SEARCHER_YEAR_OPTIONS = [5, 10, 15, 20] as const;

export const SISTER_SEARCHER_VESSEL_COLUMNS: ReadonlyArray<{
  key: keyof SisterSearcherVessel;
  label: string;
}> = [
  { key: "imo", label: "IMO" },
  { key: "vesselName", label: "Vessel Name" },
  { key: "dwt", label: "DWT" },
  { key: "design", label: "Design" },
  { key: "keelLaid", label: "Keel Laid" },
  { key: "build", label: "Build" },
  { key: "yard", label: "Yard" },
  { key: "scrubber", label: "Scrubber" },
  { key: "engineType", label: "Engine Type" },
  { key: "country", label: "Country" },
  { key: "safetyScore", label: "Safety Score" },
  { key: "ghg", label: "GHG" },
  { key: "inImos", label: "In IMOS" },
  { key: "lbp", label: "LBP" },
  { key: "depth", label: "Depth" },
  { key: "draft", label: "Draft" },
  { key: "breadth", label: "Breadth" },
  { key: "lastFixture", label: "Last Fixture" },
  { key: "mcr", label: "MCR" },
  { key: "eexi", label: "EEXI" },
  { key: "ghgType", label: "GHG Type" },
  { key: "ihsDockingSurvey", label: "IHS Docking Survey" },
  { key: "ihsSpecialSurvey", label: "IHS Special Survey" },
];

export const SISTER_SEARCHER_PERFORMANCE_SCOPES: ReadonlyArray<{
  key: SisterSearcherPerformanceScopeKey;
  label: string;
  includeNormalizedConsumption: boolean;
  normalizedConsumptionLabel?: string;
}> = [
  {
    key: "ecoBallast",
    label: "ECO Ballast",
    includeNormalizedConsumption: true,
    normalizedConsumptionLabel: "Norm. Cons @ 12.5",
  },
  {
    key: "ecoLaden",
    label: "ECO Laden",
    includeNormalizedConsumption: true,
    normalizedConsumptionLabel: "Norm. Cons @ 11.5",
  },
  { key: "fullBallast", label: "FULL Ballast", includeNormalizedConsumption: false },
  { key: "fullLaden", label: "FULL Laden", includeNormalizedConsumption: false },
];

export const SISTER_SEARCHER_PERFORMANCE_METRICS: ReadonlyArray<{
  key: SisterSearcherPerformancePointKey;
  label: string;
}> = [
  { key: "cleanSpeed", label: "Clean Speed" },
  { key: "consumption", label: "Total Cons" },
  { key: "currentSpeed", label: "Current Speed" },
  { key: "normalizedConsumption", label: "Normalized Cons" },
  { key: "cpSpeedConsumption", label: "CP Desc" },
];

export const SISTER_SEARCHER_PERFORMANCE_LEGEND = [
  { label: "Better Than CP by + 0.5 kn", background: "#00843D", text: "#FFFFFF" },
  { label: "Within + 0.5 kn Speed Abt", background: "#99CEB1", text: "#1F2937" },
  { label: "Within - 0.5 kn Speed Abt", background: "#F2C80F", text: "#1F2937" },
  { label: "Within Double Abt (-0.5 kn & +5% mT)", background: "#FE9666", text: "#1F2937" },
  { label: "Outside Double Abt (-0.5 kn & +5% mT)", background: "#FF0000", text: "#FFFFFF" },
] as const;
